import Vue from 'vue'
import Vuex from 'vuex'
// import moduleA from './moduleA'
// import router from './router' // 面包屑相关
// import resource from './resource'
import uploadUrls from './uploadUrls'
// import task from './task'
import user from './user'
Vue.use(Vuex)

const store = new Vuex.Store({

    state: {},
    mutations: {},
    actions: {},
    modules: {
        // moduleA,
        // router,
        // resource,
        uploadUrls,
        // task,
        user
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js